<template>
  <div class="filtersFooter">
    <div>
      <div>
        <!-- TODO: add dt key -->
        <span
          id="filtersFooterResults"
          class="filtersFooter__results"
        ><b>{{ resultQueryStore.state.response?.resultCount || 'not supplied by backend' }}</b> filtrerade resultat</span>
      </div>
      <div>
        <span
          id="filtersFooterPrice"
          class="filtersFooter__price"
        >{{ $lc(resultQueryStore.state.response?.metaInfo?.lowestPrice) }}</span>
      </div>
    </div>
    <div>
      <button
        class="abBtn abBtn--hideFilters"
        @click="toggleIsFilterOpen"
      >
        <span>{{ $l('showresult.filter.apply') }}</span>
      </button>
    </div>
  </div>
</template>

<script setup>
import { useFiltersStore } from './store/filtersStore';
import { useResultQueryStore } from './store/resultQueryStore';

const filtersStore = useFiltersStore();
const resultQueryStore = useResultQueryStore();


const toggleIsFilterOpen = () => {
	filtersStore.isFilterOpenToggle();
};
</script>

<style lang="scss">
.filtersFooter {
  display: flex;
  justify-content: space-between;
  flex: 0 0 6rem;
  max-height: 6rem;
  background-color: $main-btn-bg;
  color: white;
  font-size: 1.3rem;

  @include breakpoint_up(xxs) {
    font-size: 1.4rem;
  }

  & > div {
    flex: 1 1 100;

    &:first-child {
      display: flex;
      flex-direction: column;
      justify-content: center;
      padding-left: 1rem;

      @include breakpoint_up(xxs) {
        padding-left: 1.4rem;
      }
    }
  }

  button {
    height: 100%;
    border-radius: 0;
    min-width: 10rem;

    @include breakpoint_up(xxs) {
      min-width: 11rem
    }
  }

  @include breakpoint_up(md) {
    display: none;
  }
}

.filtersFooter__results {
  & > b {
    font-size: 2rem;
    font-weight: 600;
  }
}

.filtersFooter__results--noResults {
  font-size: 1.8rem;
  font-weight: 600;
}

.filtersFooter__price--noResults {
  font-size: 1.3rem;
}

.filtersFooter--large {
  flex: 0 0 60px;
  max-height: 60px;
}
</style>
